import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './NewHrUploadFile.css';

const NEW_HR_ROOT =
  process.env.REACT_APP_NEW_HR_BASE ||
  process.env.REACT_APP_HR_BASE ||
  '/new-hr';

function NewHrUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={NEW_HR_ROOT}
      sessionPrefix="new_hr_file"
    />
  );
}

NewHrUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default NewHrUploadFile;
